import { Board } from "@sportactics/board-editing";

import { useSelectBoardType } from "../select-board-type";
import { resolveBoard } from "./resolve-board";
import { useBoardActiveSWR } from "./use-board-active-swr";

export function useBoardState(): useBoardStateReturn {
  const { boardType } = useSelectBoardType();
  const { data } = useBoardActiveSWR();

  if (boardType === undefined) return { board: undefined };

  return {
    board: resolveBoard(data, boardType),
  };
}

export type useBoardStateReturn = {
  board?: Board;
};
